import { NeoState } from '~/store';

export const selectZoomIntegration = (state: NeoState) => state.zoom.integration.data[0];
